import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getGroup (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    const data = await new Promise((resolve, reject) => {
      resolve(mock.getGroups)
    })
    data.Respuesta = data.data.find(x => x.IdGrupo === Number.parseInt(params.idGrupo))
    return data
  } else {
    const req = {
      url: '/api/grupos/getgrupodetalle',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getGroup }
